import React, { useState, useEffect, useContext } from "react";
import { RejectApprovalRequest } from "../Services/ApprovalAPI";
import { useNavigate } from "react-router-dom";
import { CollectPayment } from "../Services/API";
import { hotelBookApproval } from "../Services/HotelSearchApi";
import { AuthContext } from "../Routes/AuthProvider";

const HotelApprovalDetail = ({ approvalDetails }) => {
  const { corporateId, userName } = useContext(AuthContext);
  const navigate = useNavigate();
  const [remark, setRemark] = useState("");
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);

  const booking = approvalDetails?.booking;
  const approval = approvalDetails?.requestedApprovals?.[0];

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleAccept = async () => {
    if (!approval || !booking) return;
    setIsApproving(true);
    try {
      // 1. Collect Payment
      const paymentResponse = await CollectPayment({
        transactionID: booking.bookingRefId || approval.referenceNo || "",
        referenceNo: approval.referenceNo || "",
        corporateCode: corporateId,
        userId: approval.userId || "",
        service: "Hotel",
        sessionId: booking.traceId || "",
        transactionType: "",
        remarks: remark || "Approved",
        totalAmount: Number(booking.totalPrice || 0).toFixed(2),
        creditLimit: true,
        status: "",
        paymentMode: {
          paymentModeType: approvalDetails?.corporateDetails?.companyType || "",
          cardType: "",
          productType: "",
          pgProvider: "AgencyCreditLimit",
        },
      });

      if (paymentResponse?.success || paymentResponse?.status === 1 || paymentResponse?.transactionId) {
        // 2. Hotel Book Approval
        const approvalPayload = {
          bookingRefId: booking.bookingRefId || booking.bookingRefNo || approval.referenceNo || "",
          supplierParameter: booking.supplierParameter || booking.rooms?.[0]?.supplierParameter || "",
          traceId: booking.traceId || "",
        };

        const bookApproveRes = await hotelBookApproval(approvalPayload);

        if (bookApproveRes?.success || bookApproveRes?.status === 1 || bookApproveRes?.confirmationNo) {
          alert("Booking Approved & Confirmed Successfully!");
          navigate("/hotel");
        } else {
          alert(bookApproveRes?.message || "Failed to confirm booking after approval.");
        }
      } else {
        alert(paymentResponse?.message || "Payment collection failed.");
      }
    } catch (error) {
      console.error("Error approving booking:", error);
      alert(error.message || "Failed to approve booking.");
    } finally {
      setIsApproving(false);
    }
  };

  const handleReject = async () => {
    if (!approval || !remark) {
      alert("Please provide a remark for rejection");
      return;
    }
    setIsRejecting(true);
    try {
      const requestBody = {
        // referenceNo: approval.referenceNo,
        // level1ApproverEmal: approval.level1ApproverEmail,
        // level1Approver: approval.level1Approver,
        // product: "Hotel",
        // UserId: approval.userId,
        // remark: remark,

        referenceNo: approval.referenceNo,
        level1ApproverEmail: approval.level1ApproverEmail,
        level1ApproverType: approval.level1ApproverId,
        level2ApproverEmail: approval.level2ApproverEmail,
        level2ApproverType: approval.level2ApproverId,
        product: "Hotel",
        UserId: userName,
        approvalRequestedByUserName: approval.userId,
        approvalRequestedByEmail: "",
        remark: remark
      };

      await RejectApprovalRequest(requestBody);
      alert("Approval rejected successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error rejecting approval:", error);
      alert(error.message || "Failed to reject approval");
    } finally {
      setIsRejecting(false);
    }
  };

  const [timeLeft, setTimeLeft] = useState("");
  const getRemainingTime = (blockedOn) => {
    try {
      if (!blockedOn) return "Error";
      const blockTime = new Date(blockedOn);
      if (isNaN(blockTime)) return "Invalid Date";

      const expiryTime = new Date(blockTime.getTime() + 15 * 60000);

      const diff = expiryTime - new Date();

      if (diff <= 0) return "Expired";

      const m = Math.floor(diff / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      return `${m}m ${s}s left`;
    } catch (error) {
      return "Error";
    }
  };

  const blockedOn = approvalDetails?.bookingStartTime;
  useEffect(() => {
    if (!blockedOn) {
      setTimeLeft("No Time");
      return;
    }
    setTimeLeft(getRemainingTime(blockedOn));
    const interval = setInterval(() => {
      setTimeLeft(getRemainingTime(blockedOn));
    }, 1000);
    return () => clearInterval(interval);
  }, [blockedOn]);

  if (!booking)
    return <div className="p-5 text-center">No Booking Data Available</div>;

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    if (isNaN(date.getTime())) return "-";

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(",", "")
      .replace("am", "AM")
      .replace("pm", "PM");
  };

  const getUserApprovalLevel = (approval, userName) => {
    const currentUserName = (userName || "").trim().toLowerCase();

    const level1Users = (approval.level1UserName || "")
      .split(";")
      .map(x => x.trim().toLowerCase())
      .filter(Boolean);

    const level2Users = (approval.level2UserName || "")
      .split(";")
      .map(x => x.trim().toLowerCase())
      .filter(Boolean);

    if (level1Users.includes(currentUserName)) {
      return 1;
    }

    if (level2Users.includes(currentUserName)) {
      return 2;
    }

    return 0;
  };

  return (
    <section className="wraper">
      <div className="box_shadow mt-16">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 14px",
            marginBottom: "15px",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
            background: timeLeft === "Expired" ? "#f8d7da" : "#e7f3ff",
            color: timeLeft === "Expired" ? "#842029" : "#084298",
            borderLeft: `4px solid ${timeLeft === "Expired" ? "#dc3545" : "#0d6efd"
              }`,
            zIndex: 10,
            position: "relative",
          }}
        >
          <span>⏳</span>
          <span style={{ fontWeight: "600" }}>Booking Time:</span>
          <span style={{ fontWeight: "700" }}>
            {timeLeft === "Expired"
              ? "Session Expired"
              : timeLeft || "Calculating..."}
          </span>
        </div>

        <div className="row">
          <div className="col-md-12">
            <h4 className="headings">Reason For Travel</h4>
          </div>
          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Trip ID </div>
              <div className="labl_detls">{approval?.referenceNo}</div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Travel Mode </div>
              <div className="labl_detls">Business Travel</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Employee ID </div>
              <div className="labl_detls">{approval?.employeeId}</div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Employee Name </div>
              <div className="labl_detls">{approval?.travellerName}</div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Biling Entity </div>
              <div className="labl_detls">
                {approvalDetails?.corporateDetails?.companyName}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <h4 className="headings">Travel Policy</h4>
          </div>
          <div className='col-md-6'>
            <div class="d-flex mb-3">
              <div class="labl">Policy Status </div>
              <div
                className="labl_detls"
                style={{
                  color: booking?.policyStatus === "OutOfPolicy" ? "red" : "green",
                  fontWeight: "600"
                }}
              >
                {booking?.policyStatus || "-"}
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div class="d-flex mb-3">
              <div class="labl">Policy Reason </div>
              <div className="labl_detls" style={{ color: "red" }}>{booking?.policyReason || "-"}</div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <h4 className="headings">Travel Info</h4>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Hotel Name </div>
              <div className="labl_detls">{booking.hotelName}</div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">City </div>
              <div className="labl_detls">{booking.cityName}</div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Check-In Date</div>
              <div className="labl_detls">
                {formatDate(booking.checkInDate)}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Check-Out Date</div>
              <div className="labl_detls">
                {formatDate(booking.checkOutDate)}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Total Fare </div>
              <div className="labl_detls text-danger">
                <i className="fa fa-inr"></i> {booking.totalPrice?.toLocaleString()}
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12">
            <h4 className="headings">Room & Guest Details</h4>
            {booking.rooms?.map((room, rIdx) => (
              <div key={rIdx} className="mb-4 border rounded overflow-hidden">
                <div className="bg-light p-2 fw-bold border-bottom">
                  Room {rIdx + 1}: {room.roomName} (
                  {room.refundable ? "Refundable" : "Non-Refundable"})
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead className="bg-white">
                      <tr>
                        <th style={{ width: "60px" }} className="text-center">
                          Sr.
                        </th>
                        <th>Guest Name</th>
                        <th>Type</th>
                        <th>PAN / Passport</th>
                        <th>Meal Plan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {room.paxDetails?.map((pax, pIdx) => (
                        <tr key={pIdx}>
                          <td className="text-center">{pIdx + 1}</td>
                          <td className="text-capitalize">
                            {pax.title} {pax.firstName} {pax.lastName}
                          </td>
                          <td>{pax.paxType}</td>
                          <td>{pax.panNumber || pax.passportNo || "-"}</td>
                          <td>{room.mealBasis || "N/A"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <h4 className="headings">Approvals</h4>
          </div>

          {/* ================= REQUEST ================= */}
          <div className="col-md-12">
            <div className="d-flex mb-3">
              <div className="labl">Requested By</div>
              <div className="labl_detls">
                {approval?.userId || "-"}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Submitted On</div>
              <div className="labl_detls">
                {formatDateTime(approval?.createdOn)}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Remark</div>
              <div className="labl_detls">
                {approval?.remark || "-"}
              </div>
            </div>
          </div>


          {/* ================= LEVEL 1 ================= */}
          <div className="col-md-12 mt-3">
            <div className="d-flex align-items-center justify-content-between">
              <h5 className="mb-3">
                <span className="badge bg-secondary me-2">LEVEL 1</span>
                First Level Approval
              </h5>

              {/* <span
                className={`badge ${approval?.level1ApprovalStatus === "Accepted"
                  ? "bg-warning text-dark"
                  : approval?.level1ApprovalStatus === "Rejected"
                    ? "bg-danger"
                    : "bg-warning text-dark"
                  }`}
              >
                {approval?.level1ApprovalStatus || "Requested"}
              </span> */}
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Approver(s)</div>
              <div className="labl_detls">
                <span className="badge bg-light text-dark border">
                  {approval?.level1ApproverName || "-"}
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Action By</div>
              <div className="labl_detls">
                {approval?.level1ActionBy || "-"}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Action On</div>
              <div className="labl_detls">
                {formatDateTime(approval?.level1ActionOn)}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex mb-3">
              <div className="labl">Status</div>
              <div className="labl_detls">
                <span className="badge bg-warning text-dark">
                  {approval?.level1ApprovalStatus || "Requested"}
                </span>
              </div>
            </div>
          </div>


          {/* ================= LEVEL 2 ================= */}
          {approval?.level2ApproverName?.trim() && (
            <>
              <div className="col-md-12 mt-6">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-3">
                    <span className="badge bg-secondary me-2">LEVEL 2</span>
                    Second Level Approval
                  </h5>

                  {/* <span className="badge bg-warning text-dark">
                {approval?.level2ApprovalStatus || "Requested"}
              </span> */}
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex mb-3">
                  <div className="labl">Approver(s)</div>
                  <div className="labl_detls">
                    {approval?.level2ApproverName ? (
                      <span className="badge bg-light text-dark border">
                        {approval.level2ApproverName}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex mb-3">
                  <div className="labl">Action By</div>
                  <div className="labl_detls">
                    {approval?.level2ActionBy || "-"}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex mb-3">
                  <div className="labl">Action On</div>
                  <div className="labl_detls">
                    {formatDateTime(approval?.level2ActionOn)}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex mb-3">
                  <div className="labl">Status</div>
                  <div className="labl_detls">
                    <span className="badge bg-warning text-dark">
                      {approval?.level2ApprovalStatus || "Requested"}
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ================= REJECTION REMARK ================= */}
          {/* {(approval?.level1ApprovalStatus === "Rejected" ||
            approval?.level2ApprovalStatus === "Rejected") && (
              <div className="col-md-12">
                <div className="d-flex mb-3">
                  <div className="labl">Remark</div>
                  <div className="labl_detls text-danger">
                    {approval?.remark || "-"}
                  </div>
                </div>
              </div>
            )} */}
        </div>

        {/* {approval?.level1ApprovalStatus === "Requested" && ( */}
        {/* {(
          approval.level1ApprovalStatus === "Requested" ||
          (
            approval.level1ApprovalStatus === "Approved" &&
            approval.level2ApprovalStatus === "Requested"
          )
        ) && (
          <div className="row align-items-end mt-4 p-4 border-top">
            <div className="col-md-8">
              <label className="fw-bold mb-2">Approval/Rejection Remark</label>
              <textarea
                className="form-control"
                rows="2"
                placeholder="Enter your remark here..."
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>
            </div>
            <div className="col-md-4 text-end">
              <button
                className="btn btn-success px-4 me-2"
                onClick={handleAccept}
                disabled={isApproving || isRejecting}
              >
                {isApproving ? "..." : "Approve"}
              </button>
              <button
                className="btn btn-danger px-4"
                onClick={handleReject}
                disabled={isApproving || isRejecting}
              >
                {isRejecting ? "..." : "Reject"}
              </button>
            </div>
          </div>
        )} */}

        {(() => {
          const approvalLevel = getUserApprovalLevel(approval, userName);

          const currentStatus =
            approvalLevel === 1
              ? approval.level1ApprovalStatus
              : approvalLevel === 2
                ? approval.level2ApprovalStatus
                : null;

          return currentStatus === "Requested" && (
            <div className="row align-items-end mt-4 p-4 border-top">
              <div className="col-md-8">
                <label className="fw-bold mb-2">
                  Approval/Rejection Remark
                </label>

                <textarea
                  className="form-control"
                  rows="2"
                  placeholder="Enter your remark here..."
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                ></textarea>
              </div>

              <div className="col-md-4 text-end">
                <button
                  className="btn btn-success px-4 me-2"
                  onClick={handleAccept}
                  disabled={isApproving || isRejecting}
                >
                  {isApproving ? "..." : "Approve"}
                </button>

                <button
                  className="btn btn-danger px-4"
                  onClick={handleReject}
                  disabled={isApproving || isRejecting}
                >
                  {isRejecting ? "..." : "Reject"}
                </button>
              </div>
            </div>
          );
        })()}
      </div>
    </section>
  );
};

export default HotelApprovalDetail;





